import React from 'react';
import {setLoading} from "../actions";
import {useDispatch} from "react-redux";

export default function useLoading() {
    const dispatch = useDispatch();

    return isLoading => dispatch(setLoading(isLoading));
}